<script>
  // Svelte
  import { createEventDispatcher } from 'svelte';

  // d3
  import { feature } from 'topojson-client';
  import { geoPath, geoMercator } from 'd3-geo';

  // Data
  import cityList from '../countiesMap/bigCities.js';
  import countyTopojson from '../countiesMap/california-counties-mercator.js';

  // Import
  export let data;
  export let colorScale;

  // Loads the maps
  let countyGeojson = feature(countyTopojson, countyTopojson.objects.counties);

  // Create a lookup for maps
  const mapLookup = countyGeojson.features.reduce((obj, item) => {
    obj[item.properties.COUNTYFP] = item;
    return obj;
  }, {});

  // Create a lookup for the data
  $: dataLookup = data.reduce((obj, item) => {
    obj[item.fips] = item.value;
    return obj;
  }, {});
  // Configure the mapping tools for cities
  const path = geoPath();
  const mercator = geoMercator()
    .center([-119, 37.4])
    .scale((1 << 18) / (28 * Math.PI))
    .translate([320, 320]);
  // Hover events
  const dispatch = createEventDispatcher();
  let selectedCountyMap = null;
  function selectCounty(e, push = 20) {
    const fips = e.target.getAttribute('data-fips');
    selectedCountyMap = mapLookup[fips];
    dispatch('mapActivateCounty', {
      fips,
    });
  }
  function deselectCounty(e) {
    const fips = e.target.getAttribute('data-fips');
    selectedCountyMap = null;
    dispatch('mapDeactivateCounty', {
      fips,
    });
  }
</script>

<svg viewBox="0 0 640 640">
  <g class="county-layer">
    {#each countyGeojson.features as obj}
      <path
        d={path(obj)}
        class="county"
        data-name={obj.properties.NAME}
        data-fips={obj.properties.COUNTYFP}
        data-value={dataLookup[obj.properties.COUNTYFP]}
        fill={colorScale(dataLookup[obj.properties.COUNTYFP])}
        stroke="white"
        on:mouseover={selectCounty}
        on:mouseout={deselectCounty}
      />
    {/each}
  </g>
  <g class="hover-layer">
    {#if selectedCountyMap}
      <path
        d={path(selectedCountyMap)}
        fill="none"
        stroke-width="2.5"
        stroke="black"
      />
    {/if}
  </g>
  <g class="cities">
    {#each cityList as obj}
      <g
        data-name={obj.name}
        transform="translate({mercator([obj.long, obj.lat])})"
      >
        <circle r="4" class="city" />
        <text
          class="halo"
          dx={obj.orientation == 'right' ? '8px' : '-8px'}
          dy="6px"
          text-anchor={obj.orientation == 'right' ? 'start' : 'end'}
        >
          {obj.name}
        </text>
        <text
          class="text"
          dx={obj.orientation == 'right' ? '8px' : '-8px'}
          dy="6px"
          text-anchor={obj.orientation == 'right' ? 'start' : 'end'}
        >
          {obj.name}
        </text>
      </g>
    {/each}
  </g>
</svg>
